// Platform bridge (docs/08 §platform, docs/09 Phase 7). On the web every call is a no-op; inside the
// Electron build the preload script exposes `window.mawNative`, which forwards to Steam (achievements,
// Rich Presence, the INSATIABLE leaderboard) and writes the save to userData for Steam Auto-Cloud.

export interface NativeBridge {
  /** Mirror the save into userData/save.json (Steam Auto-Cloud syncs that file). */
  saveWrite(text: string): void;
  achievement(steamId: string): void;
  /** Rich Presence tokens (see docs/12-steam.md for the localization file). */
  presence(tokens: Record<string, string>): void;
  score(board: string, value: number): void;
  setFullscreen(on: boolean): void;
  /** Focus changes of the window (pause on focus loss). */
  onFocus(cb: (focused: boolean) => void): void;
  quit(): void;
}

declare global {
  interface Window {
    mawNative?: NativeBridge;
  }
}

const native = (): NativeBridge | undefined => (typeof window !== 'undefined' ? window.mawNative : undefined);

/** Steam's achievement API names: `MAW_A01` … `MAW_A40` (set up in Steamworks with these ids). */
export const steamAchievementId = (id: string): string => `MAW_${id}`;
/** The Steam leaderboard for INSATIABLE (highest tribute reached). */
export const ENDLESS_BOARD = 'INSATIABLE';

export const platform = {
  get native(): boolean {
    return !!native();
  },
  unlock(id: string): void {
    native()?.achievement(steamAchievementId(id));
  },
  /** "Tribute 23 · RAVENOUS": Steam shows it in the friends list. */
  presence(tribute: number, mood: string): void {
    native()?.presence({ steam_display: '#Status', tribute: String(tribute), mood });
  },
  endlessScore(n: number): void {
    native()?.score(ENDLESS_BOARD, n);
  },
  saveMirror(text: string): void {
    native()?.saveWrite(text);
  },
  setFullscreen(on: boolean): void {
    native()?.setFullscreen(on);
  },
  onFocus(cb: (focused: boolean) => void): void {
    const n = native();
    if (n) n.onFocus(cb);
    else if (typeof window !== 'undefined') {
      window.addEventListener('blur', () => cb(false));
      window.addEventListener('focus', () => cb(true));
    }
  },
};
